import Vue from "vue";
import Router from "vue-router";
import Layout from "@/components/Layout";
//
Vue.use(Router);

/**
 *
 * sidebar 菜单对应路由
 *
 * 权限控制两种方式
 * 1、
 * meta: {
                permission: {
                    m: ['user','xxxxx'],// must 字符串 或者 字符串数组：   必须要满足所有的权限key 不填表示无权限控制
                    o: 'xxx'，// option 字符串 或者 字符串数组： 可选的权限 至少满足一个权限即可
                }
            },
 * 2、
 * meta: {
                permission: ['user','admin','trader'] // 字符串 或者 字符串数组：   必须要满足所有的权限key 不填表示无权限控制
            },
 *
 */
export const asyncRouteMap = [
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    meta: {},
    children: [
      {
        path: "/home",
        name: "Home",
        meta: {
          tab: "index",
          header: false,
          showBack: false,
          title: "渔在船加油",
          type: "user"
        },
        component: () => import("@/views/home/index")
      },
      // 仓库
      {
        path: "/warehouse",
        name: "Warehouse",
        meta: {
          tab: "warehouse",
          header: false,
          keepalive: true
        },
        component: () => import("@/views/warehouse/index")
      },
      // 订单
      {
        path: "/order",
        name: "Order",
        meta: {
          tab: "order",
          header: false,
          alive: true,
          type: "user"
        },
        component: () => import("@/views/order/index")
      },
      {
        path: "/weather",
        name: "weather",
        meta: {
          tab: null,
          alive: true,
          type: "user"
        },
        component: () => import("@/views/weather/index")
      },
      {
        path: "/order/:id",
        name: "orderDetail",
        props: true,
        meta: {
          type: "user"
        },
        component: () => import("@/views/order/detail")
      },
      {
        path: "/order/:id/oilAppointHistory",
        name: "oilAppointHistory",
        props: true,
        meta: {
          type: "both"
        },
        component: () => import("@/views/order/oilAppointHistory")
      },
      {
        path: "/order/oilAppointMap/:id",
        name: "oilAppointMap",
        props: true,
        meta: {
          type: "both"
        },
        component: () => import("@/views/order/oilAppointMap")
      },
      {
        path: "/order/:id/oilConfirm",
        name: "oilConfirm",
        props: true,
        meta: {
          type: "both"
        },
        component: () => import("@/views/order/oilConfirm")
      },
      {
        path: "/order/:id/shipConfirm",
        name: "shipConfirm",
        props: true,
        meta: {
          type: "both"
        },
        component: () => import("@/views/order/shipConfirm")
      },
      {
        path: "/order/:id/billConfirm",
        name: "billConfirm",
        props: true,
        meta: {
          type: "both"
        },
        component: () => import("@/views/order/billConfirm")
      },
      {
        path: "/order/:id/addOrder",
        name: "addOrder",
        props: true,
        meta: {
          type: "both"
        },
        component: () => import("@/views/salesman/addOrder")
      },
      // 订单下单详情
      {
        path: "/order/buy/:id",
        name: "orderBuyDetail",
        props: true,
        meta: {
          type: "user"
        },
        component: () => import("@/views/order/orderBuyDetail")
      },
      {
        path: "/buySuccess",
        name: "buySuccess",
        meta: {
          alive: true,
          tab: null,
          type: "user"
        },
        component: () => import("@/views/order/buySuccess")
      },
      // 我的
      {
        path: "/profile",
        name: "Profile",
        meta: {
          tab: "profile",
          header: false,
          type: "user"
        },
        component: () => import("@/views/user/myInfo")
      },
      {
        path: "/profile/step1",
        name: "ProfileStep1",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/step1")
      },
      {
        path: "/profile/accountInfo",
        name: "accountInfo",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/accountInfo")
      },
      {
        path: "/profile/accountInfo1",
        name: "accountInfo1",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/accountInfo1")
      },
      {
        path: "/profile/creditCard",
        name: "creditCard",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/creditCard")
      },
      // 我的信息修改
      {
        path: "/user/myInfoChange",
        name: "myInfoChange",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/myInfoChange")
      },
      // 银行卡
      {
        path: "/bankCard/bankCard",
        name: "bankCard",
        meta: {
          type: "user"
        },
        component: () => import("@/views/bankCard/bankCard")
      },
      // 添加银行卡
      {
        path: "/bankCard/addBankCard",
        name: "addBankCard",
        meta: {
          type: "user"
        },
        component: () => import("@/views/bankCard/addBankCard")
      },
      // 解绑银行卡
      {
        path: "/bankCard/unbind/:id",
        name: "unbind",
        meta: {
          type: "user"
        },
        component: () => import("@/views/bankCard/unbind")
      },
      // 已激活银行卡的企业列表
      {
        path: "/bankCard/companySelect",
        name: "companySelect",
        meta: {
          type: "user"
        },
        component: () => import("@/views/bankCard/companySelect")
      },
      // 添加公司银行卡
      {
        path: "/bankCard/addCompanyBankCard/:companyId",
        name: "addCompanyBankCard",
        meta: {
          type: "user"
        },
        component: () => import("@/views/bankCard/addCompanyBankCard")
      },
      // 提现
      {
        path: "/cashOut/cashOut",
        name: "cashOut",
        component: () => import("@/views/cashOut/cashOut")
      },
      // 渔船列表
      {
        path: "/ship/shipList",
        name: "shipList",
        meta: {
          type: "user"
        },
        component: () => import("@/views/ship/shipList")
      },
      // 渔船详情
      {
        path: "/ship/shipDetail/:id",
        props: true,
        name: "shipDetail",
        meta: {
          type: "user"
        },
        component: () => import("@/views/ship/shipDetail")
      },
      // 绑定渔船号
      {
        path: "/ship/bindShipNum",
        name: "bindShipNum",
        meta: {
          type: "user"
        },
        component: () => import("@/views/ship/bindShipNum")
      },
      // 添加渔船
      {
        path: "/ship/addShip",
        name: "addShip",
        meta: {
          type: "user"
        },
        component: () => import("@/views/ship/addShip")
      },
      // 业务员首页
      {
        path: "/salesman/index",
        name: "salesman",
        meta: {
          showBack: false,
          header: false,
          title: "渔在船加油",
          type: "admin"
        },
        component: () => import("@/views/salesman/index")
      },
      {
        path: "/salesman/order/:id",
        name: "salesmanOrder",
        props: true,
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/order")
      },
      // //油品采购合同
      // {
      //   path: "/salesman/hetong/:id",
      //   name: "salesmanHetong",
      //   props: true,
      //   component: () => import("@/views/salesman/hetong")
      // },
      // 待审核
      {
        path: "/salesman/pending",
        name: "pending",
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/pending")
      },
      // 跟进中
      {
        path: "/salesman/follow",
        name: "follow",
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/follow")
      },
      // 买家确认
      {
        path: "/salesman/buyerConfirm",
        name: "buyerConfirm",
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/buyerConfirm")
      },
      // 待付款
      {
        path: "/salesman/pay",
        name: "pay",
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/pay")
      },
      // 新增订单
      {
        path: "/salesman/newOrder/:id",
        name: "newOrder",
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/newOrder")
      },
      // 订单列表
      {
        path: "/salesman/orderList",
        name: "orderList",
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/orderList")
      },
      // 完成
      {
        path: "/salesman/finsh",
        name: "finsh",
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/finsh")
      },
      {
        path: "/company/addCompany",
        name: "addCompany",
        meta: {
          type: "user"
        },
        component: () => import("@/views/company/addCompany")
      },
      // 协议模板详情
      {
        path: "/user/templateDetail",
        name: "templateDetail",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/templateDetail")
      },
      // 协议展示
      {
        path: "/user/frameShow",
        name: "frameShow",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/frameShow")
      },
      // 用户协议签署页面
      {
        path: "/user/userFrame",
        name: "userFrame",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/userFrame")
      },
      {
        path: "/order/shareOrder/:id",
        name: "shareOrder",
        meta: {
          type: "both"
        },
        component: () => import("@/views/order/shareOrder")
      },
      {
        path: "/bindIdCard/bindStep2",
        name: "bindStep2",
        meta: {
          type: "user"
        },
        component: () => import("@/views/bindIdCard/bindStep2")
      },
      {
        path: "/withdraw/withdraw",
        name: "withdraw",
        component: () => import("@/views/withdraw/withdraw")
      },
      {
        path: "/withdraw/success",
        name: "withdraw",
        meta: {
          type: "user"
        },
        component: () => import("@/views/withdraw/success")
      },
      {
        path: "/bankCard/addClientBankCard",
        name: "addClientBankCard",
        meta: {
          type: "user"
        },
        component: () => import("@/views/bankCard/addClientBankCard")
      },
      {
        path: "/bindIdCard/activeCompanyCard",
        name: "activeCompanyCard",
        meta: {
          type: "user"
        },
        component: () => import("@/views/bindIdCard/activeCompanyCard")
      },
      {
        path: "/user/userInfo",
        name: "userInfo",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/userInfo")
      },
      {
        path: "/user/identity",
        name: "identity",
        meta: {
          type: "user"
        },
        component: () => import("@/views/user/identity")
      },
      {
        path: "/identify/companyIdentify",
        name: "companyIdentify",
        meta: {
          type: "user"
        },
        component: () => import("@/views/identify/companyIdentify")
      },
      {
        path: "/identify/legalPersonIdentify",
        name: "legalPersonIdentify",
        meta: {
          type: "user"
        },
        component: () => import("@/views/identify/legalPersonIdentify")
      },
      {
        path: "/company/companyList",
        name: "companyList",
        meta: {
          type: "user"
        },
        component: () => import("@/views/company/companyList")
      },
      {
        path: "/identify/companyDetail/:id",
        name: "identifyCompanyDetail",
        meta: {
          type: "user"
        },
        component: () => import("@/views/identify/companyDetail")
      },
      {
        path: "/identify/companyEdit/:id",
        name: "companyEdit",
        meta: {
          type: "user"
        },
        component: () => import("@/views/identify/companyEdit")
      },
      {
        path: "/user/noticeCenter",
        name: "noticeCenter",
        meta: {
          type: "both"
        },
        component: () => import("@/views/user/noticeCenter")
      },
      {
        path: "/user/pictures",
        name: "userPictures",
        meta: {
            type: "both",
            title: "证照信息",
        },
        component: () => import("@/views/user/pictures")
      },
      // 新增国际贸易订单
      {
        path: "/salesman/addNewI",
        name: "addNewI",
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/addNewI")
      },
      // 国际贸易订单详情
      {
        path: "/salesman/intOrder/:id",
        name: "salesmanIntOrder",
        meta: {
          type: "admin"
        },
        component: () => import("@/views/salesman/intOrder")
      },
      // 国际贸易订单分享详情
      {
        path: "/order/shareIntOrder/:id",
        name: "intOrderDetail",
        meta: {
          type: "both"
        },
        component: () => import("@/views/order/shareIntOrder")
      },
      {
        path: "/intOrder/:id",
        name: "intDetail",
        props: true,
        meta: {
          type: "user"
        },
        component: () => import("@/views/order/intDetail")
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

/**
 *  必然存在的路由表
 */
export const routerMap = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/user/autoLogin"),
    hide: true,
    meta: {
      requestAuth: false,
      type: "user"
    }
  },
  {
    path: "/zlbLogin/index",
    name: "zlbLogin",
    hide: true,
    meta: {
      requestAuth: false,
      type: "user"
    },
    component: () => import("@/views/zlbLogin/index")
  },
  {
    path: "/traderLogin",
    name: "traderLogin",
    component: () => import("@/views/user/traderLogin"),
    hide: true,
    meta: {
      requestAuth: false,
      type: "admin"
    }
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/user/register")
  },
  {
    path: "/overPage",
    name: "overPage",
    component: () => import("@/views/appPage/overPage")
  },
  {
    path: "/404",
    component: () => import("@/views/error/404.vue"),
    hidden: true
  }
];

export function NoAuthRouter(url) {
  if (routerMap.find(x => x.path === url)) {
    return true;
  }
  return false;
}

const createRouter = routes => {
  return new Router({
    mode: "history",
    base: "/",
    routes: routes
  });
};

const router = createRouter(routerMap);

export async function resetRouter(routes) {
  const newRouter = createRouter(routes);
  router.matcher = newRouter.matcher;
}

export default router;
